import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import asyncService from "../../services/common/asyncService";
import suggestMap from "./suggestmap";
import $ from 'jquery';
import IsdTextBox from "./isdTextBox";
import { isUndefined } from "../../util/util";
import authService from "../../services/common/authService";
import { observer } from "mobx-react";
import stateStore from "../../store/stateStore";
const IsdTextboxSuggest = observer(React.forwardRef((props, ref) => {
    //dispatchを宣言しておく
    const dispatch = useDispatch();
    const textInput = useRef(null);
    const dataListRef = useRef(null);
    const [isOpenSuggest, setIsOpenSuggest] = useState(false);
    const [isChange, setIsChange] = useState(false);
    const [data, setData] = useState([]);
    let renderDataList = "";

    useEffect(() => {
        const newData = [];
        const datas = stateStore.state[props.data];
        if (datas && datas.length) {
            Object.values(datas).map(data => {
                let label = '';
                let value = '';
                let search = '';
                if (props.suggestFields) {
                    const dataSearch = props.searchFields ? props.searchFields : props.suggestFields;
                    Object.values(props.suggestFields).map((item, index) => {
                        if (index === props.suggestFields.length - 1) {
                            label += data[item];
                        } else {
                            label += `${data[item]} : `;
                        }
                    })
                    Object.values(dataSearch).map((item) => {
                        search += data[item];
                    })
                    if (props.labelField)
                        value = props.labelField ? data[props.labelField] : data[props.suggestFields[0]];
                }
                newData.push({ label: label, value: value, search: search });
            })
            setData(newData);
        }
    }, [props.data, stateStore.state[props.data]]);

    useEffect(() => {
        if (props.suggest) {
            // TODO logic
            dispatch(suggestMap.item(props.suggest, asyncService, authService)).then((data) => {
                setData(data);
            })
        }
        textInput.current.element.addEventListener("mousedown", (event) => {
            setIsOpenSuggest(true);
        })

        // サジェストプルダウン上の選択肢クリックイベントです
        document.body.addEventListener("mousedown", (event) => {
            // サジェストダイアログでサジェスト項目コードを変更する
            if (getDataList()) {
                if (event.target.nodeName === 'OPTION' && event.target.parentNode.classList.contains('select-suggest')) {
                    const eventChange = {
                        target: {
                            name: props.name,
                            value: event.target.value,
                            suggetItem: event.target.innerText
                        }
                    };
                    handleInputChange(eventChange);
                    setIsChange(true);
                    clear();
                    focusText();
                    return;
                }
                if (textInput.current && event.target !== textInput.current.element && event.target.tagName !== 'DATALIST') {
                    clear();
                }
            }
        });
        // 画面リサイズイベントです
        window.addEventListener('resize', function (event) {
            // 選択肢が表示されている場合
            if (getDataList()) {
                clear();
            }
        });
        // サジェストプルダウン上のマウス移動イベントです
        document.body.addEventListener("mouseover", function (event) {
            if (getDataList()) {
                if (event.target.nodeName === 'OPTION' && event.target.parentNode.classList.contains('select-suggest')) {
                    if (!dataListRef.current) return;
                    const optionSelect = dataListRef.current.querySelector('option.active');
                    if (optionSelect) {
                        optionSelect.classList.remove('active');
                    }
                }
            }
        });
        document.body.addEventListener("wheel", function (event) {
            // 選択肢が表示されている場合
            let flag = false;
            if (getDataList() && (event.target.tagName === 'DATALIST'
                || (event.target.nodeName === 'OPTION' && event.target.parentNode.classList.contains('select-suggest')))) {
                flag = true;
            }
            if (!flag) {
                clear();
            }
        });
    }, []);

    useImperativeHandle(ref, () => ({
        element: textInput.current.element,
        checkSuggest: checkSuggest.bind(this)
    }));

    // サジェストダイアログを表示します
    const show = (element) => {
        element.classList.add('filter');
        element.classList.remove('hide');
    };
    // サジェストダイアログを閉じます
    const hide = (element) => {
        element.classList.add('hide');
        element.classList.remove('filter');
    };
    // サジェストダイアログの項目をクリアします
    const clear = () => {
        setIsOpenSuggest(false);
        if (!dataListRef.current) return;
        const optionSelect = dataListRef.current.querySelector('.active');
        const optionFilterList = dataListRef.current.querySelectorAll('.filter');
        // 活性化されている選択肢があれば、削除する
        if (optionSelect) {
            optionSelect.classList.remove('active');
        }
        // 表示されている選択肢があれば、非表示にする
        if (optionFilterList.length) {
            Object.values(optionFilterList).map(option => {
                option.classList.remove('filter');
                option.classList.add('hide');
            })
        }
    };
    //入力変更時に実行されるイベント
    const handleInputChange = (event) => {
        const { name, value, suggetItem } = event.target;
        if (props.suggestCd) {
            const value = suggetItem ? suggetItem.split(":")[0].trim() : "";
            stateStore.setState(props.suggestCd, value);
        }
        stateStore.setState(name, value);
        if (!isUndefined(props.onChange)) {
            props.onChange(event);
        }
        const text = textInput.current ? textInput.current.element.value : '';
        if (!text) {
            setIsOpenSuggest(false);
        } else {
            setIsOpenSuggest(true);
        }
        // テキストボックスに入力した値でサジェスト項目を絞り込む
        setTimeout(() => {

            const select = getDataList();
            if (select) {
                let isShow = false;
                let top = 0;
                if (props.selectbox) {
                    top = 2;
                    select.style.width = `${props.selectbox.current.element.getBoundingClientRect().width}px`;
                }
                select.style.position = "absolute";
                select.style.zIndex = "999";
                select.style.top = `${textInput.current.element.getBoundingClientRect().height + top + 1}px`;
                select.style.left = "0";
                select.parentElement.style.position = "relative";
                let index = 0;
                for (let option of select.options) {
                    // 絞り込んだ項目をサジェストダイアログに表示す
                    if (option.id.indexOf(text) > -1) {
                        show(option);
                        index++;
                        if (!isShow) {
                            isShow = true;
                        }
                    } else {
                        hide(option);
                    }
                };
                // 入力したデータがサジェスト項目リストに見つかっている場合、サジェストプルダウンを表示する
                if (isShow) {
                    if (index > 5) {
                        select.style.maxHeight = '111px';
                    }
                    select.style.display = "inline-block";
                } else {
                    clear();
                }
            }
        }, 100);

    };

    const onKeydown = (event) => {
        if (!getDataList()) {
            return;
        }
        const select = getDataList();
        //サジェストダイアログでサジェスト項目コードを変更する
        if (event.key === 'Enter' || (event.key === "Process" && event.keyCode === 229)) {
            const optionSelect = select.querySelector('option.active');
            if (optionSelect) {
                const value = optionSelect.value;
                if (event.key === 'Enter') {
                    const eventChange = {};
                    eventChange.target = {
                        name: props.name,
                        value: value,
                        suggetItem: event.target.innerText
                    }
                    handleInputChange(eventChange);
                    focusText();
                }
                event.preventDefault();
                event.stopPropagation();
            }
        }

        // サジェストダイアログで上へ／下へキーを押す
        const optionLength = select.options.length;
        if (optionLength && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
            let optionSelected = null;
            const posSelect = select.getBoundingClientRect();
            const topSelect = posSelect.top;
            const heightSelect = posSelect.height;
            let index = 0;
            const options = select.querySelectorAll('.filter');
            // 選択肢が表示されている場合
            if (options && options.length) {
                for (let i = 0; i < options.length; i++) {
                    const optionElement = options[i];
                    if (optionElement.classList.contains('active')) {
                        optionSelected = optionElement;
                        index = i;
                    }
                }
            }

            // 上へ／下へキー押しでフォーカスした項目を選択する
            if (optionSelected) {
                optionSelected.classList.remove('active');
                if (event.key === 'ArrowDown') {
                    optionSelected = Array.prototype.slice.call(options).indexOf(options[index + 1]) >= 0 ?
                        options[index + 1] : optionSelected;
                } else {
                    optionSelected = Array.prototype.slice.call(options).indexOf(options[index - 1]) >= 0 ?
                        options[index - 1] : optionSelected;
                }
                const posOption = optionSelected.getBoundingClientRect();
                const topOption = posOption.top;
                const heightOption = posOption.height;
                const scrollDown = $(select).scrollTop() + ($(select).find(optionSelected).offset().top - $(select).offset().top);
                if (topOption >= (topSelect + heightSelect - 1)) {
                    $(select).scrollTop(scrollDown);
                }
                if (topSelect > topOption) {
                    $(select).scrollTop(scrollDown - (heightSelect - heightOption));
                }
                optionSelected.classList.add('active');
            } else if (event.key === 'ArrowDown' && (options && options.length)) {
                options[0].classList.add('active');
            }
        }
        // タブキーイベントまたはエンターキーイベントが終了した時、サジェストプルダウンを閉じる
        if (event.key === 'Tab' || event.key === 'Enter' || (event.key === "Process" && event.keyCode === 229)) {
            clear();
        }
    }

    const onBlur = (event) => {
        if (isChange) {
            setIsChange(false);
            return;
        }
        if (props.onBlur) props.onBlur(event);
    }


    const getDataList = () => {
        return document.body.querySelector('.select-suggest');
    }

    const checkSuggest = () => {
        const dataList = getDataList();
        return !dataList ? false : (dataList.style.display === 'inline-block') ? true : false;
    }

    const focusText = () => {
        setTimeout(() => {
            if (textInput.current) {
                textInput.current.element.focus();
                textInput.current.element.select();
            }
        }, 10);
    }

    if (isOpenSuggest) {
        renderDataList = (<datalist id={`${props.suggest ? props.suggest : props.id}Suggest`} ref={dataListRef} className="select-suggest" role="listbox">
            {data.map((item, i) => {
                return (<option id={item.search} value={item.value}>{item.label}</option>)
            })}
        </datalist>)
    }

    return (<>
        <IsdTextBox className={props.className}
            required={props.required}
            onKeydown={onKeydown}
            onBlur={onBlur}
            disabled={props.disabled}
            id={props.name}
            name={props.name}
            value={props.value}
            ref={textInput}
            ctrlproptype="japan"
            isdmaxlength={props.isdmaxlength}
            searchform={props.searchform}
            onChange={handleInputChange} />
        {isOpenSuggest && renderDataList}
    </>);

}))
export default IsdTextboxSuggest;